export default __webpack_public_path__ + "media/images/features/toyono/illust_left-26382738df7bdb233ce7d67fe885c63b.png";